export const TRANSFER_NOTE_STRINGS = {
  warning: "Transfers are permanent and can't be reversed",
  transferredLabel: "What's transferred:",
  transferredItems:
    'Resume, completed activities, scorecards, forms, conversations, notes and files',
  notTransferredLabel: "What's not transferred:",
  notTransferredItems:
    'Scheduled or pending activities, active offers and AI score',
} as const;
